import { AnyAction } from "redux";
import { RESET, SET_REQUEST } from "./core/actions";
import { defContext, IContext } from "./Context";
import { Actions } from "@my-dld/actions";

const defaultState: IContext = defContext;
export { defaultState as DefaultState };

export function Reducer( state: IContext = defaultState, action: AnyAction ) {
	switch ( action.type ) {
		case SET_REQUEST:
			return { ...state, request: action.payload };
		case RESET:
		case Actions.USER_LOGGED_OUT:
			return { ...defaultState };
		default:
			return state;
	}
}

declare module "@my-dld/reducers/store" {
	interface IStore {
		PropertyHandTakeOver: IContext,
	}
}
